import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
var EmstreeComponent = /** @class */ (function () {
    function EmstreeComponent(deviceManagerSer, transMngSer, EmsdashboardService) {
        this.deviceManagerSer = deviceManagerSer;
        this.transMngSer = transMngSer;
        this.EmsdashboardService = EmsdashboardService;
        this.currentUserData = JSON.parse(localStorage.getItem('userData'));
        this.arr1 = [];
        this.hoverData = [];
    }
    EmstreeComponent.prototype.ngOnInit = function () {
        this.getDeiceIds();
        this.getEnergymetrId();
    };
    EmstreeComponent.prototype.getEnergymetrId = function () {
        var _this = this;
        var user_id = this.currentUserData.userid;
        var roleid = this.currentUserData.roleid;
        this.EmsdashboardService.getEnergyMeterIds({ "userid": user_id, "roleid": roleid }).subscribe(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        console.log("all id's", response);
                        this.metermanagerdata = response.data;
                        _a = this;
                        return [4 /*yield*/, response.data.map(function (meter) { return meter.meterSerialNumber; })];
                    case 1:
                        _a.allmetersid = _b.sent();
                        this.getmetername();
                        return [2 /*return*/];
                }
            });
        }); });
    };
    EmstreeComponent.prototype.getAlertCount = function (meterCount) {
        var _this = this;
        console.log("response of alert", meterCount);
        this.EmsdashboardService.gethoverdatatree({ "meterid": this.allmetersid, "meterCount": meterCount }).toPromise().then(function (response) {
            _this.hoverData = response.result;
        });
    };
    EmstreeComponent.prototype.getAlertDataOnHover = function (energyMeterIdArray) {
        var l1 = 0;
        var l2 = 0;
        var l3 = 0;
        var pf = 0;
        var kwh = 0;
        var l_kwh = 0;
        this.hoverData.forEach(function (lastData) {
            if (lastData.energyMeterId == energyMeterIdArray.meterid) {
                l1 = lastData.L1;
                l2 = lastData.L2;
                l3 = lastData.L3;
                pf = Number(lastData.pf).toFixed(2);
                kwh = lastData.kwh;
                l_kwh = lastData.latestkwh;
            }
        });
        var tooltipText = "Meter Name : " + energyMeterIdArray.meterName + "\n";
        this.alert_count = 0;
        tooltipText += "Alerts : " + energyMeterIdArray.alert + "\n";
        tooltipText += "parameterName : " + energyMeterIdArray.parameterName + "\n";
        tooltipText += "Metrid : " + energyMeterIdArray.meterid + "\n";
        tooltipText += "L1 : " + l1 + "\n";
        tooltipText += "L2 : " + l2 + "\n";
        tooltipText += "L3 : " + l3 + "\n";
        tooltipText += "PF : " + pf + "\n";
        tooltipText += "KWH : " + kwh + "\n";
        tooltipText += "Latest KWH : " + l_kwh + "\n";
        this.dataTooltip = tooltipText;
    };
    EmstreeComponent.prototype.getDeiceIds = function () {
        var _this = this;
        this.deviceManagerSer.getEMSDeviceId(JSON.parse(localStorage.getItem('userData')).userid).subscribe(function (response) {
            if (response.result.length > 0) {
                var Deviceids_1 = [];
                response.result.forEach(function (value) {
                    Deviceids_1.push(value.deviceId + "(" + value.sitename + ")");
                });
                _this.Deviceid = Deviceids_1[0];
                _this.uniqueDeviceId = Deviceids_1;
            }
        });
    };
    EmstreeComponent.prototype.getmetername = function () {
        var _this = this;
        this.EmsdashboardService.getAlertData({ "meterid": this.allmetersid }).toPromise().then(function (response) {
            var secondarray = response.result;
            console.log("second array", secondarray);
            console.log("first array", _this.metermanagerdata);
            var mergearray = [];
            secondarray.forEach(function (secondItem) {
                var firstItem = _this.metermanagerdata.find(function (item) { return item.meterSerialNumber === secondItem.meterSerialNumber; });
                if (firstItem) {
                    mergearray.push(tslib_1.__assign({}, firstItem, secondItem));
                }
            });
            console.log("Merged Array", mergearray);
            var floorMap = new Map();
            mergearray.forEach(function (value) {
                var floorName = value.meterDescription;
                var meterName = value.assetName;
                var meterno = value.meterSerialNumber;
                var alert = value.alertCount;
                var thisdevice = value.deviceId;
                var parameters = value.parameterNames;
                if (floorMap.has(floorName)) {
                    var floorArray = floorMap.get(floorName);
                    floorArray.push({ floor: floorName, meterName: meterName, alert: alert, parameterName: parameters, meterid: meterno, device: thisdevice });
                }
                else {
                    var floorArray = [{ floor: floorName, meterName: meterName, alert: alert, parameterName: parameters, meterid: meterno, device: thisdevice }];
                    floorMap.set(floorName, floorArray);
                }
            });
            _this.energyMeterIdArray = Array.from(floorMap.values());
            console.log("This array : energyMeterIdArray", _this.energyMeterIdArray);
            _this.getAlertCount(_this.allmetersid.length);
        });
    };
    return EmstreeComponent;
}());
export { EmstreeComponent };
function getSanitizedTooltip() {
    throw new Error('Function not implemented.');
}
